import AboutProfilemodule from "../components/about/AboutProfilemodule";
import Gallerylist from "../components/about/Gallerylist";
import "../styles/AboutProfilemodule.css";
import Seo from "../components/generic/Seo";

const objSeo = {
  title: "Springevening Private Limited -Minds That Transcend.",
  keywords:
    "startup, Software company, Soochi ERP, HappyNenapu, Flipbook, Shyam, shyamsunder sedamkar, sedamkar, shivoo, ashok sutagundar, BEC,Empowering developers, Training, Internship, Bagalkot, BEC, sedamkar, North Karnataka",
  pathSlug: "/about",
  description:
    "Minds That Transcend is a technology startup founded by Shyamsunder Sedamkar, focusing on creating hyper-local solutions that have a tangible impact on communities. The company is dedicated to empowering small businesses with innovative software solutions like Soochi ERP and Happy Nenapu Flipbook.",
};

const AboutUs = () => {
  return (
    <>
      <Seo data={objSeo} />;
      <div class="appbg aboutuscontainer">
        <h5 className="products-demo mb-3">
          ABOUT <span className="text-accent sepl">SPRINGEVENING</span>
        </h5>

        <h1 className="about-title">
          Building Practical Technology, Rooted in Local Impact
        </h1>

        <p className="about-description text-secondary">
          <span className="text-accent sepl">
            Springevening Private Limited
          </span>{" "}
          is a Bagalkot-based software company creating digital products and
          custom solutions for real-world problems. With global industry
          experience and a strong local focus, we build reliable software that
          supports businesses, institutions, and local talent.
        </p>

        <AboutProfilemodule
          image="..\assets\About\shyamphoto.jpeg"
          pageTitle="Shyamsunder Sedamkar"
          designation="CEO Springevening Private Limited "
          description="Shyamsunder Sedamkar is a technology startup founder with a focus on creating hyper-local solutions that have a tangible impact on communities. Shyamsunder holds a bachelor degree from Karnataka University and M.S from Illinois Institute of Technology, Chicago.Shyamsunder has successfully led teams."
          fblink="https://www.facebook.com/Shyamsunder.Sedamkar"
          linkdin="https://www.linkedin.com/in/sedamkar/"
        ></AboutProfilemodule>

        <AboutProfilemodule
          image="..\assets\About\bheemsenphoto.jpeg"
          pageTitle="Bheemsen Sedamkar"
          designation="Director/Business Advisor"
          description="B.S. Sedamkar holds an engineering degree and an MBA from Manipal Institute of Technology. He joined his father's business at Shri Vijaya Concrete Works, overseeing the construction of three major railway bridges. Additionally, he successfully established and manages Amogh RMC, a 30 cubic meter capacity plant with transit mixer vehicles.  "
        ></AboutProfilemodule>

        <AboutProfilemodule
          image="..\assets\About\ashokphoto.jpeg"
          pageTitle="Dr. Ashok Sutagundar"
          designation="Academic Advisor"
          description="Ashok V. Sutagundar completed his B. E in Electronics and Communication Engineering from Karnatak University Dharwad, India and M.Tech from Visvesvaraya Technological University Belgaum, India. He has completed his Ph.D in the area of Wireless Sensor Networks (WSNs)."
          fblink="https://www.facebook.com/ashok.sutagundar"
          linkdin="https://in.linkedin.com/in/dr-ashok-sutagundar-b1aa2557"
        ></AboutProfilemodule>

        <AboutProfilemodule
          image="..\assets\About\chaitra.jpg"
          pageTitle="Chaitra Sathyanarayana"
          designation=" CPO/Director, Springevening Private Limited"
          description="Chaitra Sathyanarayana is a highly motivated individual with a passion for education and project management. She holds a Bachelor of Engineering (BE) degree in Computer Science from Bangalore. With a keen eye for detail and exceptional verbal communication skills, Chaitra excels in managing multiple schedules and making appointments efficiently."
        ></AboutProfilemodule>

        <Gallerylist></Gallerylist>
      </div>
    </>
  );
};

export default AboutUs;
